import React, {Component, Fragment} from 'react';

import classNames from 'classnames';
import {generateId} from '../../shared/utils';
import i18n from '../../shared/i18n/i18n';


import FieldText from '../../SharedComponent/FieldText/FieldText';
import FieldDateTime from '../../SharedComponent/FieldDateTime/FieldDateTime';
import FieldRadio from '../../SharedComponent/FieldRadio/FieldRadio';

export default class FieldSetNames extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };

        this.ui = {
            firstName: React.createRef(),
            lastName: React.createRef(),
            middleName: React.createRef(),
            birthdate: React.createRef(),
            gender: React.createRef(),
        };

        this.setValue = this.setValue.bind(this);
        this.getValue = this.getValue.bind(this);
        this.setError = this.setError.bind(this);

    }

    setError(message = '', errorFields = [],) {
        if (errorFields.length === 0) {
            this.ui.firstName.current.setError(message);
            this.ui.lastName.current.setError(message);
            this.ui.middleName.current.setError(message);
            this.ui.birthdate.current.setError(message);
        } else {
            errorFields.forEach(item => {
                if (item === 'firstName') {
                    this.ui.firstName.current.setError(message);
                }
                if (item === 'lastName') {
                    this.ui.lastName.current.setError(message);
                }
                if (item === 'middleName') {
                    this.ui.middleName.current.setError(message);
                }
                if (item === 'birthdate') {
                    this.ui.birthdate.current.setError(message);
                }
            });
        }
    }

    setValue(data) {
        this.ui.firstName.current.setValue(data.firstName || '');
        this.ui.lastName.current.setValue(data.lastName || '');
        this.ui.middleName.current.setValue(data.middleName || '');
        this.ui.birthdate.current.setValue(data.birthdate || '');
        this.ui.gender.current.setValue(data.gender || '');
    }

    getValue() {
        return {
            firstName: this.ui.firstName.current.getValue(),
            lastName: this.ui.lastName.current.getValue(),
            middleName: this.ui.middleName.current.getValue(),
            birthdate: this.ui.birthdate.current.getValue(),
            gender: this.ui.gender.current.getValue(),
        };
    }

    render() {
        return (
            <div className="fb-row">
                <FieldText ref={this.ui.lastName} setting={this.props.setting} option={{
                    label: "LAST_NAME",
                    type: "text",
                    value: "",
                    size: 20,
                    onChange: function (value) {
                        return value.length <= 100;
                    },
                }}/>
                <FieldText ref={this.ui.firstName} setting={this.props.setting} option={{
                    label: "FIRST_NAME",
                    type: "text",
                    value: "",
                    size: 20,
                    onChange: function (value) {
                        return value.length <= 100;
                    },
                }}/>
                <FieldText ref={this.ui.middleName} setting={this.props.setting} option={{
                    label: "MIDDLE_NAME",
                    type: "text",
                    value: "",
                    size: 20,
                    onChange: function (value) {
                        return value.length <= 100;
                    },
                }}/>
                <FieldDateTime ref={this.ui.birthdate} setting={this.props.setting} option={{
                    label: "BIRTH_DATE",
                }}/>
                <FieldRadio ref={this.ui.gender} setting={this.props.setting} option={{
                    label: "GENDER",
                    value: 'M',
                    radio: [
                        {
                            id: 1,
                            label: "MASCULINE",
                            value: 'M',
                            enabled: true,
                        },
                        {
                            id: 2,
                            label: "FEMININE",
                            value: 'F',
                            enabled: true,
                        },
                    ]
                }}/>
            </div>
        );
    }
}